export const EVENT_UPDATE_MAIN_URL:string = 'mainUrl';

export const EVENT_SAVE_WEBSHOP:string = 'webshopDialogSave';

export const EVENT_DUPLICATE_COMPANY_SELECTED:string = 'duplicateCompanySelected';
export const EVENT_COMPANY_UPDATED:string = 'companyUpdated';

export const EVENT_SAVE_GLOBALPRODUCT:string = 'saveGlobalProduct';
export const EVENT_GLOBAL_PRODUCT_IMAGES_LOADED:string = 'globalproductImages';

export const EVENT_USER_PROFILE_UPDATED:string = 'userProfileUpdated';
export const EVENT_TRANSLATION_UPDATED:string = 'translationUpdated';

export const EVENT_ORDER_WEBSHOP_LIST_UPDATED:string = 'orderWebshopListUpdated';
export const EVENT_ORDER_COUNTRY_LIST_UPDATED:string = 'orderCountryListUpdated';
export const EVENT_ORDER_BP_LIST_UPDATED:string = 'orderBPListUpdated';
export const EVENT_ORDER_WEBSHOP_SELECTION_UPDATED:string = 'orderWebshopSelectionUpdated';
export const EVENT_ORDER_COUNTRY_SELECTION_UPDATED:string = 'orderCountrySelectionUpdated';
export const EVENT_ORDER_BP_SELECTION_UPDATED:string = 'orderBPSelectionUpdated';
export const EVENT_ORDER_CONTEXT_UPDATED:string = 'orderContextUpdated';
export const EVENT_ORDER_LOADING_CONTEXT:string = 'orderLoadingContext';

export const EVENT_ORDER_CATEGORIES_LOADED:string = 'orderCategoriesLoaded';
export const EVENT_ORDER_CATALOG_PRODUCTS_CHANGED:string = 'orderCatalogProductsChanged';
export const EVENT_ORDER_CURRENCY_CHANGED:string = 'orderCurrencyChanged';
export const EVENT_ORDER_EXT_CATEGORY_CHANGED:string = 'orderCatalogSingleExternalCategoryChanged';
export const EVENT_ORDER_CART_CURRENCY_CHANGED:string = 'orderCartCurrencyChanged';
export const EVENT_ORDER_CART_PRICE_CHANGED:string = 'orderCartPriceChanged';
export const EVENT_ORDER_CART_FEE_CHANGED:string = 'orderCartFeeChanged';
export const EVENT_ORDER_CART_STATUS_UPDATED:string = 'orderCartStatusUpdated';
export const EVENT_ORDER_CART_COUNT_CHANGED:string = 'orderCartCountChanged';
export const EVENT_ORDER_INFO_TAG_FIELD_CHANGED:string = 'orderInfoTagFieldChanged';
export const EVENT_ORDER_INFO_TAG_FIELD2_CHANGED:string = 'orderInfoTagField2Changed';
export const EVENT_ORDER_INFO_PO_NUMBER_CHANGED:string = 'orderInfoCustomerPONumberChanged';
export const EVENT_ORDER_PAYMENT_LIST_CHANGED:string = 'orderInfoPaymentListChanged';
export const EVENT_ORDER_TAX_PERCENTAGE_CHANGED:string = 'orderChargesTaxPercentageChanged';
export const EVENT_ORDER_CHARGES_CHANGED:string = 'orderChargesChanged';
export const EVENT_ORDER_BUSY_STATUS_CHANGED:string = 'orderBusyStatusChanged';

export const EVENT_ORDER_LOADING_COUNTRIES:string = 'orderLoadingCountries';
export const EVENT_ORDER_LOADING_BPS:string = 'orderLoadingBPs';
export const EVENT_ORDER_REQUESTER_CONTACT_CHANGED:string = 'orderRequesterContactChanged';

export const EVENT_BREADCRUMBS_CHANGED:string = 'breadcrumbsChanged';
export const EVENT_REPORT_ACTION_DONE:string = 'eventReportActionDone';
export const EVENT_REPORT_ACTION_ERROR:string = 'eventReportActionError';

export const EVENT_DASHBOARD_REMOVE_REPORTS:string = 'eventDashboardRemoveReports';

export const EVENT_PERMISSIONS_SELECTED:string = 'permissionsSelected';

export const EVENT_EXPORT_REPORT:string = 'exportReport';

export const EVENT_SAVE_FAQ:string = 'faqSave';